import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_ZONE_RESET = 'PUT_ZONE_RESET';
export const PUT_ZONE_LOADING = 'PUT_ZONE_LOADING';
export const PUT_ZONE_SUCCESS = 'PUT_ZONE_SUCCESS';
export const PUT_ZONE_REJECT = 'PUT_ZONE_REJECT';

//* ACTIONS ------------------------------------------------
export const putZoneReset = () => ({ type: PUT_ZONE_RESET });
export const putZoneLoading = () => ({ type: PUT_ZONE_LOADING });
export const putZoneSuccess = (payload) => ({ type: PUT_ZONE_SUCCESS, payload });
export const putZoneReject = (payload) => ({ type: PUT_ZONE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putZoneRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/api/Zones`, options);
};


